import { Checkbox, Row } from 'antd';
import React from 'react';
import NumberFormat from 'react-number-format';
import { GUTTOR_SPACE } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

const FormCheckboxGroup = (props: any): any => {
  const formConfig = useGetFormConfig(props);
  const {
    disabled,
    onChange = (event: any): any => { },
    key,
    options,
  } = formConfig;

  return (
    <FormItem formConfig={formConfig}>
      <Checkbox.Group
        data-testid={key}
        disabled={disabled}
        onChange={onChange}
      >
        {
          options.map(({ value, name, packageCost }: any): any => (
            <Row gutter={GUTTOR_SPACE} key={value}>
              <Checkbox
              value={value}
              className="customPackageCheckbox mt-md"
            >
              <span className="pkg-name">{name}</span>
              <span className="pkg-cost">
                <NumberFormat
                  value={packageCost}
                  displayType="text"
                  prefix="Rs. "
                  thousandSeparator={true}
                  thousandsGroupStyle="lakh"
                />
              </span>
            </Checkbox>
            </Row>
          ))
        }
      </Checkbox.Group>
    </FormItem>
  );
};
export default FormCheckboxGroup;
